import { create } from "zustand";

interface UserLoginStore {
  sessionId: string | null;
  setSessionId: (
    sessionId: string,
    storageType: "localStorage" | "sessionStorage"
  ) => void;
  clearSession: () => void;
}

const getSessionIdFromStorage = (): string | null => {
  return localStorage.getItem("s") || sessionStorage.getItem("s") || null;
};

const saveSessionIdToStorage = (
  sessionId: string,
  storageType: "localStorage" | "sessionStorage"
): void => {
  switch (storageType) {
    case "localStorage":
      localStorage.setItem("s", sessionId);
      break;
    case "sessionStorage":
      sessionStorage.setItem("s", sessionId);
      break;
    default:
      throw new Error("Invalid storage type");
  }
};

const removeSessionIdFromStorage = (): void => {
  localStorage.removeItem("s");
  sessionStorage.removeItem("s");
};

export const useLoginStore = create<UserLoginStore>((set) => ({
  sessionId: getSessionIdFromStorage(),
  setSessionId: (sessionId, storageType) => {
    set({ sessionId });
    saveSessionIdToStorage(sessionId, storageType);
  },
  clearSession: () => {
    set({ sessionId: null });
    removeSessionIdFromStorage();
  },
}));

